import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SearchComponent } from './search/search.component';
import { MyBookingsItemComponent } from './my-bookings-item/my-bookings-item.component';
import { ListLoadingAnimationComponent } from './list-loading-animation/list-loading-animation.component';
import { PlaceLocationInfoComponent } from './place-location-info/place-location-info.component';
import { LanguageSwitchComponent } from './language-switch/language-switch.component';
import { AddFavoritePlacesComponent } from './add-favorite-places/add-favorite-places.component';
import { FloorplanSearchpopoverComponent } from './search/floorplan-searchpopover/floorplan-searchpopover.component';
import { FavoriteMapItemComponent } from './favorite-map-item/favorite-map-item.component';
import { ItemLoadingComponent } from './item-loading/item-loading.component';
import { DatetimeFormatSettingComponent } from './datetime-format-setting/datetime-format-setting.component';
import { PlaceComponent } from './place/place.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { PlacesSettingsComponent } from './places-settings/places-settings.component';
import { SwiperCalendarComponent } from './swiper-calendar/swiper-calendar.component';
import { AddFavoriteMapsComponent } from './add-favorite-maps/add-favorite-maps.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { WeatherWidgetComponent } from './widgets/weather-widget/weather-widget.component';
import { BookingsWidgetComponent } from './widgets/bookings-widget/bookings-widget.component';
import { HideTabsDirective } from '../directives/hide-tabs.directive';
import { UnleashFeatureDirective } from '../directives/unleash-feature.directive';
import { PortalFeedComponent } from './widgets/portal-feed/portal-feed.component';
import { WorkingHoursWidgetComponent } from './widgets/working-hours-widget/working-hours-widget.component';
import { LocationWidgetComponent } from './widgets/location-widget/location-widget.component';
import { BrandWidgetComponent } from './widgets/brand-widget/brand-widget.component';
import { AvaliableTimeBookingPage } from '../avaliable-time-booking/avaliable-time-booking.page';
import { EventComponent } from './event/event.component';
import { ModalHeaderComponent } from './modal-header/modal-header.component';
import { SanitizeHtmlPipe } from '../services/html-sanitizer/htmlsanitizer.service';
import { BookingStepperComponent } from './booking-stepper/booking-stepper.component';
import { SearchpopoverComponent } from './search/searchpopover/searchpopover.component';
import { EventDescriptionModalComponent } from './event-description-modal/event-description-modal.component';
import { ActiveSearchRequestPreviewComponent } from './active-search-request-preview/active-search-request-preview.component';
import { AppLoadingComponent } from './components/app-loading/app-loading.component';
import { AddAttendeeComponent } from './add-attendee/add-attendee.component';
import { ErrorSectionComponent } from './error-section/error-section.component';
import { SuccessErrorReportModalComponent } from './success-error-report-modal/success-error-report-modal.component';
import { CalendarComponent } from '../calendar-view/calendar/calendar.component';
import { AddResourceComponent } from './add-resource/add-resource.component';
import { CalendarViewModalComponent } from './calendar-view-modal/calendar-view-modal.component';
import { CalendarDaysComponent } from '../calendar-view/calendar-days/calendar-days.component';
import { DailyCalendarModalPage } from 'src/app/modals/daily-calendar-modal/daily-calendar-modal.page';
import { BookingDetailsPage } from '../booking-details/booking-details.page';
import { ErrorModalComponent } from '../modals/error-modal/error-modal.component';
import { AppUpdateModalComponent } from '../modals/app-update-modal/app-update-modal.component';
import { BookingTimerComponent } from './booking-timer/booking-timer.component';
import { FindColleagueComponent } from './find-colleague/find-colleague.component';
import { FindColleagueWidgetComponent } from './widgets/find-colleage-widget/find-colleague-widget.component';
import { AiChatComponent } from './ai-chat/ai-chat.component';
import { AiChatEventDetailPipe } from './ai-chat/ai-chat-event-detail.pipe';
import { AiChatApprovalSummaryPipe } from './ai-chat/ai-chat-approval-summary.pipe';
import { AiChatMessageSegmentsPipe } from './ai-chat/ai-chat-message-segments.pipe';
import { MyBookingsItemCompactComponent } from './my-bookings-item-compact/my-bookings-item-compact.component';
import { ViewEditBookingComponent } from './view-edit-booking/view-edit-booking.component';
import { ProposeNewTimeComponent } from './propose-new-time/propose-new-time.component';
import { ProposeNewTimeListComponent } from './propose-new-time-list/propose-new-time-list.component';
import { MyBookingsItemLegacyComponent } from './my-bookings-item-legacy/my-bookings-item-legacy.component';
import { MarkdownModule } from 'ngx-markdown';
import { ResourceAvailabilityComponent } from './resource-availability/resource-availability.component';
import { ResourceWeekCalendarComponent } from './resource-availability/resource-week-calendar/resource-week-calendar.component';

@NgModule({
  declarations: [
    SearchComponent,
    SearchpopoverComponent,
    MyBookingsItemComponent,
    ListLoadingAnimationComponent,
    PlaceLocationInfoComponent,
    LanguageSwitchComponent,
    AddFavoritePlacesComponent,
    FloorplanSearchpopoverComponent,
    FavoriteMapItemComponent,
    ItemLoadingComponent,
    DatetimeFormatSettingComponent,
    PlaceComponent,
    PlacesSettingsComponent,
    OnboardingComponent,
    SwiperCalendarComponent,
    AddFavoriteMapsComponent,
    MainHeaderComponent,
    WeatherWidgetComponent,
    BookingsWidgetComponent,
    HideTabsDirective,
    UnleashFeatureDirective,
    PortalFeedComponent,
    WorkingHoursWidgetComponent,
    LocationWidgetComponent,
    BrandWidgetComponent,
    SearchpopoverComponent,
    AvaliableTimeBookingPage,
    EventComponent,
    ModalHeaderComponent,
    SanitizeHtmlPipe,
    BookingStepperComponent,
    EventDescriptionModalComponent,
    ActiveSearchRequestPreviewComponent,
    AppLoadingComponent,
    AddAttendeeComponent,
    ErrorSectionComponent,
    SuccessErrorReportModalComponent,
    AddResourceComponent,
    CalendarViewModalComponent,
    DailyCalendarModalPage,
    BookingDetailsPage,
    ErrorModalComponent,
    AppUpdateModalComponent,
    BookingTimerComponent,
    FindColleagueWidgetComponent,
    FindColleagueComponent,
    AiChatComponent,
    AiChatEventDetailPipe,
    AiChatApprovalSummaryPipe,
    AiChatMessageSegmentsPipe,
    MyBookingsItemCompactComponent,
    ViewEditBookingComponent,
    ProposeNewTimeComponent,
    ProposeNewTimeListComponent,
    MyBookingsItemLegacyComponent,
    ResourceAvailabilityComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule.forChild(),
    MarkdownModule,
    CalendarComponent,
    CalendarDaysComponent,
    ResourceWeekCalendarComponent,
  ],
  exports: [
    SearchComponent,
    SearchpopoverComponent,
    MyBookingsItemComponent,
    ListLoadingAnimationComponent,
    PlaceLocationInfoComponent,
    LanguageSwitchComponent,
    AddFavoritePlacesComponent,
    FloorplanSearchpopoverComponent,
    FavoriteMapItemComponent,
    ItemLoadingComponent,
    DatetimeFormatSettingComponent,
    PlaceComponent,
    PlacesSettingsComponent,
    OnboardingComponent,
    SwiperCalendarComponent,
    AddFavoriteMapsComponent,
    MainHeaderComponent,
    WeatherWidgetComponent,
    BookingsWidgetComponent,
    HideTabsDirective,
    UnleashFeatureDirective,
    PortalFeedComponent,
    WorkingHoursWidgetComponent,
    LocationWidgetComponent,
    BrandWidgetComponent,
    SearchpopoverComponent,
    AvaliableTimeBookingPage,
    EventComponent,
    ModalHeaderComponent,
    SanitizeHtmlPipe,
    BookingStepperComponent,
    EventDescriptionModalComponent,
    ActiveSearchRequestPreviewComponent,
    AppLoadingComponent,
    AddAttendeeComponent,
    ErrorSectionComponent,
    SuccessErrorReportModalComponent,
    AddResourceComponent,
    CalendarViewModalComponent,
    DailyCalendarModalPage,
    BookingDetailsPage,
    ErrorModalComponent,
    AppUpdateModalComponent,
    BookingTimerComponent,
    FindColleagueWidgetComponent,
    FindColleagueComponent,
    AiChatComponent,
    MyBookingsItemCompactComponent,
    ViewEditBookingComponent,
    ProposeNewTimeComponent,
    ProposeNewTimeListComponent,
    MyBookingsItemLegacyComponent,
    ResourceAvailabilityComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
